import {AxiosResponse} from "axios";
import {appyShopConfig} from "../config";
import {config} from "../config-merchant";
import {ReviewProductList} from "../interfaces/review-interface";

const axios = require('axios');

export function getProductListToReview(language: string, token: string): Promise<AxiosResponse<ReviewProductList>> {
    return axios.get(appyShopConfig.apiUrl + config.merchantId + '/' + language + '/review/' + token);
}

export function sendProductReview(language: string, token: string, body: any): Promise<AxiosResponse> {
    return axios.put(appyShopConfig.apiUrl + config.merchantId + '/' + language + '/review/' + token, body);
}
